import React, { useState } from 'react';
import { Row } from "react-bootstrap/";
import appConfig from '../../config/app.js';

const PRICE_LOOKUP_KEY = { 
    standard_monthly: 'standard_monthly',
};

const PricingPlans = ({ 
    auth, 
    searchId = null, 
    showToggle = false, 
    onPlanSelect = null,
    isOnboarding = false 
}) => {
    const [loadingStates, setLoadingStates] = useState({
        standard_monthly: false,
    });
    
    const handlePaymentSubmit = async (planKey) => {
        const lookupKey = PRICE_LOOKUP_KEY[`${planKey}_monthly`];
        
        // Set loading state for this specific plan
        setLoadingStates(prev => ({
            ...prev,
            [lookupKey]: true
        }));

        try {
            // Use fetch instead of form submission to properly use the proxy
            const response = await fetch('/api/post/stripe/create-checkout-session', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    lookup_key: lookupKey
                })
            });

            if (response.ok) {
                const result = await response.json();
                if (result.url) {
                    // Redirect to Stripe checkout
                    window.location.href = result.url;
                } else {
                    throw new Error('No checkout URL received');
                }
            } else {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
        } catch (error) {
            console.error('Error submitting payment form:', error);
            // Reset loading state on error
            setLoadingStates(prev => ({
                ...prev,
                [lookupKey]: false
            }));
        }
    };

    const renderPlanCard = (planKey, plan) => {
        const price = plan.monthlyPrice;
        const period = appConfig.pricing.pricingText.monthly;
        
        let headerStyle = {};
        if (planKey === 'standard') {
            headerStyle = {backgroundColor: "#067100AA"};
        }

        // Determine the current lookup key for loading state
        const currentLookupKey = PRICE_LOOKUP_KEY[`${planKey}_monthly`];
        const isLoading = loadingStates[currentLookupKey];

        return (
            <div className="col-lg-6 col-12 p-1" key={planKey}>
                <div className="card h-100" style={{border: "2px solid #067100"}}>
                    <div className="card-header text-center text-white" style={headerStyle}>
                        <h5 className="mb-0">{plan.name}</h5>
                    </div>
                    <div className="card-body d-flex flex-column">
                        <div className="text-center mb-3">
                            <span className="h2">${price}</span>
                            <span className="text-muted">/{period}</span>
                            <div className="text-warning mt-1" style={{ fontSize: '0.8rem', fontWeight: '500' }}>
                                💰 Get $10 Venmo credit - contact founder in Discord after payment
                            </div>
                        </div>
                        <p className="text-muted text-center mb-3">{plan.description}</p>
                        <ul className="list-unstyled mb-4 flex-grow-1">
                            {plan.featuresList.map((feature, index) => (
                                <li key={index} className="mb-2">
                                    <i className="fas fa-check text-success me-2"></i>
                                    {feature}
                                </li>
                            ))}
                        </ul>
                        <button
                            className="btn btn-success w-100"
                            onClick={() => handlePaymentSubmit(planKey)}
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                    Processing...
                                </>
                            ) : (
                                `${appConfig.pricing.pricingText.select} - $${price}/${period}`
                            )}
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            <Row>
                <div className="d-lg-flex mt-2 justify-content-center">
                    {Object.entries(appConfig.pricing.plans).map(([planKey, plan]) => 
                        renderPlanCard(planKey, plan)
                    )}
                </div>
            </Row>
        </>
    );
};

export default PricingPlans;
